import React from "react";
import { Card, CardContent, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import { SwitchIngreso } from "./SwitchIngreso";
import { crearRelacionDocumentacionSubtipoEfector, modificarTipoDocumentacionPorSubtipoEfector, eliminarTipoDocumentacionPorSubtipoEfector } from "../../../../../actions/contrataciones/configuraciones/tipoDocumentacionPorSubtipoEfector";

const useStyles = makeStyles({
  root: {
    background: '#212121'
  }
});

export const FormIngresoEfectorDocumentacion = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { idSubTipoEfector } = props;
  const { documentacionPorSubTipoEfectores } = useSelector((state) => state.tipoDocumentacionesEfectores)
  
  const { items:data } = useSelector((state) => state.documentos)

  const handleDelete = (idTipoDocumentacionesEfectoresPorSubTipoEfector) => {
    dispatch(eliminarTipoDocumentacionPorSubtipoEfector(idTipoDocumentacionesEfectoresPorSubTipoEfector));
  };

  const handleEditar = (idTipoDocumentacionesEfectoresPorSubTipoEfector, obligatorio) => {
    let body = {
      idTipoDocumentacionesEfectoresPorSubTipoEfector,
      obligatorio
    }
    dispatch(modificarTipoDocumentacionPorSubtipoEfector(idTipoDocumentacionesEfectoresPorSubTipoEfector, body));
  };

  const handleCrear = (idTipoDocumentaciones) => {
    let body = {
      idTipoDocumentacionesEfectores: idTipoDocumentaciones,
      idSubTipoEfector,
    }
    dispatch(crearRelacionDocumentacionSubtipoEfector(body));
  };

  return (
    <Card className={classes.root}>
      <CardContent>
        {
          documentacionPorSubTipoEfectores && data.map(res => {
            const tieneDocumentacion = documentacionPorSubTipoEfectores.find(e => e.idTipoDocumentacionesEfectores === res.idTipoDocumentaciones)
            return <SwitchIngreso
              key={res.idTipoDocumentaciones}
              id={res.idTipoDocumentaciones}
              label={res.descripcionDocumentacion}
              obligatorio={tieneDocumentacion ? tieneDocumentacion.obligatorio : false}
              seleccionado={tieneDocumentacion ? true : false}
              idTipoDocumentacionesSubtipoEfectores={tieneDocumentacion ? tieneDocumentacion.idTipoDocumentacionesEfectoresPorSubTipoEfector : null}
              handleDelete={handleDelete}
              handleEditar={handleEditar}
              handleCrear={handleCrear}
            />
          })
        }
      </CardContent>
    </Card>
  );
};